import { render, staticRenderFns } from "./TesteExtrato.vue?vue&type=template&id=187a2b76&scoped=true&"
import script from "./TesteExtrato.vue?vue&type=script&lang=js&"
export * from "./TesteExtrato.vue?vue&type=script&lang=js&"
import style0 from "./TesteExtrato.vue?vue&type=style&index=0&id=187a2b76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a2b76",
  null
  
)

export default component.exports